import type { CategoryId, ICategory } from "app/common/services/categoryService.types";

export const findCategoryById = (categories: ICategory[], id: CategoryId): ICategory => {
    let foundCategory = categories.find((category) => category.id === id);
    if (foundCategory) {
        return foundCategory;
    }

    for (const category of categories) {
        if (category.children) {
            foundCategory = findCategoryById(category.children, id);
            if (foundCategory) {
                return foundCategory;
            }
        }
    }
};
